export const isValidEmail = (email, domainCheck = false) => {
  if (domainCheck) {
    return /.@.*\./.test(email);
  }

  return /.@./.test(email);
};

/**
 * Normalizes an email address for comparison purposes. Email addresses are
 * stored as typed (i.e, an invitation keeps whatever casing the PRO used),
 * so they must be normalized before comparing them against each other.
 *
 * @param {String} [email] The email address to normalize.
 * @returns {String} The normalized email address.
 */
export const normalizeEmail = email => (email ?? '').trim().toLowerCase();

export const maskEmail = email => {
  if (!email) return '';
  const [user, domain] = email.split('@');
  if (user.length <= 2) return email;
  return `${user[0]}${'*'.repeat(5)}${user[user.length - 1]}@${domain}`;
};
